"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDescriptor;

var _types = require("@plugnet/types");

var _util = require("@plugnet/util");

// Copyright 2017-2019 @polkadot/extrinsics authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * From the metadata of a function in the module's storage, generate the function
 * that will return the an UncheckExtrinsic.
 *
 * @param index - Index of the module section in the modules array.
 */
function createDescriptor(section, method, index, meta) {
  const callIndex = new Uint8Array([index, meta.id.toNumber()]);
  let extrinsicFn;

  const expectedArgs = _types.Method.filterOrigin(meta);

  extrinsicFn = function extrinsicFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (0, _util.assert)(expectedArgs.length.valueOf() === args.length, "Extrinsic ".concat(section, ".").concat(method, " expects ").concat(expectedArgs.length.valueOf(), " arguments, got ").concat(args.length, "."));
    return new _types.Method({
      args,
      callIndex
    }, meta);
  };

  extrinsicFn.callIndex = callIndex;
  extrinsicFn.meta = meta;
  extrinsicFn.method = method;
  extrinsicFn.section = section;

  extrinsicFn.toJSON = () => meta.toJSON();

  return extrinsicFn;
}